<template>
  <div class="contacts">
    <div class="wrapper">
      <h1>Контакты</h1>
      <div class="contacts__name">Контактные данные:</div>
      <div class="contacts__data">
        <a href="tel:+79264496896" title="Позвонить" class="contacts__data-link">
          <span class="contacts__data-icon">
            <svg class="contacts__data-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
              <path d="M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm48-60V92c0-6.6-5.4-12-12-12H92c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h136c6.6 0 12-5.4 12-12zm80-308v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-48 410V54c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v404c0 3.3 2.7 6 6 6h212c3.3 0 6-2.7 6-6z"/>
            </svg>
          </span>
          +7 (926) 449-68-96
        </a>
        <a href="mailto:kandinskiy@inbox.ru" title="Написать письмо" class="contacts__data-link">
          <span class="contacts__data-icon">
            <svg class="contacts__data-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
              <path d="M990,781.1V218.9L702,500L990,781.1z M10,240.6v518.7L275.7,500L10,240.6z M897,805.7l-254-248L488.9,708.1L334.8,557.7l-254.1,248H897z M488.9,592.7L897,194.3H80.7L488.9,592.7z"/>
            </svg>
          </span>
          kandinskiy@inbox.ru
        </a>
      </div>
      <FormContacts></FormContacts>
    </div>
  </div>
</template>

<script>
import FormContacts from '../components/FormContacts.vue'

export default {
  name: "Contacts",
  components: {
    FormContacts
  }
}
</script>

<style lang="scss" scoped>
  .contacts {
    position: relative;

    &__name {
      margin: 25px 0 0;
      font-family: Roboto-Bold, sans-serif;
      @include font(16px, 20px, $color-dark-gray);
    }

    &__data {
      margin: 15px 0 0;
      font-size: 0;

      &-link {
        display: block;
        @include font(14px, 18px, $color-link);
        text-decoration: none;

        @media screen and (min-width: 768px){
          display: inline-block;
        }

        & + & {
          margin: 10px 0 0;

          @media screen and (min-width: 768px){
            margin: 0 0 0 35px;
          }
        }

        &:hover {
          color: $color-link-hover;
        }
      }

      &-icon {
        margin-right: 3px;
      }

      &-svg {
        position: relative;
        top: 3px;
        height: 15px;
        fill: $color-link;
        max-width: 100%;
        transition: linear .3s;

        a:hover & {
          fill: $color-link-hover;
        }
      }
    }
  }
</style>